// import { Capacitor } from "@capacitor/core";

import Vue from "vue";
import App from "./App.vue";
import VueCookies from "vue-cookies";
import "./registerServiceWorker";
//import "./firebase-messagin-sw";
import router from "./router";
import store from "./store";
import axios from "axios";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  setInteractionMode
} from "vee-validate";
import VModal from "vue-js-modal";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueLoaders from "vue-loaders";
import mixins from "./mixins/mixins";
import VuePromiseBtn from "vue-promise-btn";
import {
  required,
  email,
  min_value,
  max_value,
  length,
  regex
} from "vee-validate/dist/rules";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/he";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import SvgIcon from "./components/SvgIcon";
import VueAutosuggest from "vue-autosuggest";
import moment from "moment";
import VueTheMask from "vue-the-mask";
import VueIntro from "vue-introjs";
import "intro.js/introjs.css";
import "intro.js/introjs-rtl.css";

// import "vue2-timepicker/dist/VueTimepicker.css";

import "vue-instant/dist/vue-instant.css";
import VueInstant from "vue-instant/dist/vue-instant.common";
import VueMatomo from "vue-matomo";

Vue.use(VueMatomo, {
  host: "https://md-tracker.hmc.co.il/",
  siteId: 3
});
window._paq.push(["trackPageView"]); //To track pageview

Vue.use(VueInstant);
Vue.use(VueAutosuggest);
Vue.use(VueCookies);
Vue.use(VueTheMask);
Vue.use(VueIntro);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
setInteractionMode("passive");
Vue.$cookies.config("1d");
// No message specified.
extend("email", email);
extend("min_value", min_value);
extend("max_value", max_value);
extend("length", length);
extend("regex", regex);
extend("birth_date", {
  getMessage: field => "תאריך לידה אינו תקין",
  message: "תאריך לידה אינו תקין",
  validate: value => {
    const date = moment(value, "DD/MM/YYYY");
    const now = moment();
    if (date.isSameOrAfter(now)) return false;
    const age = date.diff(moment(), "years") * -1;
    if (age > 120) return false;
    return true;
  }
});
extend("date_before_today", {
  getMessage: field => "לתשומת ליבך, ניתן לבקש בלוק לתאריך עתידי בלבד",
  message: "לתשומת ליבך, ניתן לבקש בלוק לתאריך עתידי בלבד",
  validate: value => {
    const date = moment(value, "DD/MM/YYYY");
    const now = moment();
    if (date.isSameOrBefore(now)) return false;
    return true;
  }
});
extend("valid_date", {
  getMessage: field => "תאריך אינו תקין",
  message: "תאריך אינו תקין",
  validate: value => {
    const date = moment(value, "DD/MM/YYYY");
    return date.isValid();
  }
});
extend("isBigger", {
  getMessage: field => "שעת סיום קטנה/שווה לשעת התחלה",
  message: "שעת סיום קטנה/שווה לשעת התחלה",
  validate: (value, [otherValue]) => {
    if (!value || !otherValue) return true;
    if (value === "00:00") value = "24:00";
    return value > otherValue;
  },
  hasTarget: true
});
extend("isSmallest", {
  getMessage: field => "שעת התחלה גדולה/שווה לשעת סיום",
  message: "שעת התחלה גדולה/שווה לשעת סיום",
  validate: (value, [otherValue]) => {
    if (!value || !otherValue) return true;
    if (otherValue === "00:00") otherValue = "24:00";
    return value < otherValue;
  },
  hasTarget: true
});
extend("max", {
  getMessage: field => "מעל שעת מקסימום",
  message: "מעל שעת מקסימום",
  validate: (value, [otherValue, date]) => {
    if (!value) return true;
    const day = moment(date, "DD/MM/YYYY").day();
    if (otherValue === "00:00") otherValue = "24:00";
    if (day == 5) {
      return value <= otherValue && value <= "15:00";
    } else {
      return value <= otherValue;
    }
  },
  hasTarget: true
});
extend("min", {
  getMessage: field => "מתחת לשעת מינימום",
  message: "מתחת לשעת מינמום",
  validate: (value, [otherValue]) => {
    if (!value || !otherValue) return true;
    if (value === "00:00") value = "24:00";
    return value >= otherValue;
  },
  hasTarget: true
});
extend("duration", {
  getMessage: field => "מינימום שעה",
  message: "מינימום שעה",
  validate: (value, [otherValue]) => {
    let end = moment(value, "HH:mm");
    let start = moment(otherValue, "HH:mm");
    let duration = moment.duration(end.diff(start));
    let hours = duration.asHours();
    if (!value || !otherValue) return true;
    if (otherValue === "00:00") otherValue = "24:00";
    return hours >= 1;
  },
  hasTarget: true
});
extend("interval", {
  getMessage: field => "מרווחים של 5 דקות בלבד",
  message: "מרווחים של 5 דקות בלבד",
  validate: (value, [otherValue]) => {
    if (!value || value === "HH:mm") return true;
    let minutes = moment(value, "HH:mm").minutes();
    if (minutes % 5 === 0) return true;
    return false;
  },
  hasTarget: true
});
extend("durationInterval", {
  getMessage: field => "מרווחים של 5 דקות בלבד",
  message: "מרווחים של 5 דקות בלבד",
  validate: (value, [otherValue]) => {
    if (value === 0 || value === "0") return false;
    if (!value) return true;
    let minutes = parseInt(value);
    if (minutes % 5 === 0) return true;
    return false;
  },
  hasTarget: true
});
extend("timeFormat", {
  getMessage: field => "תצורה אינה נכונה של זמן",
  message: "תצורה אינה נכונה של זמן",
  validate: (value, [otherValue]) => {
    if (value.length === 5) return true;
    return false;
  },
  hasTarget: true
});
extend("israeliId", {
  getMessage: field => "תעודת זהות אינה תקינה",
  message: "תעודת זהות אינה תקינה",
  validate: (value, [otherValue]) => {
    if (otherValue) return true;
    let id = String(value).trim();
    if (id.length > 9 || isNaN(id)) return false;
    id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
    return (
      Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) %
        10 ===
      0
    );
  },
  hasTarget: true
});
extend("requiredSurgTime", {
  message: "שדה חובה",
  validate: (value, [otherValue]) => {
    if (!otherValue) return true;
    if (otherValue && value && value != "HH:mm") return true;
    return false;
  }
});
// Override the default message.
extend("required", {
  ...required,
  message: "שדה חובה"
});
extend("length", {
  ...length,
  message: "יש להזין מספר של 6 ספרות"
});
extend("regex", {
  ...regex,
  message: "מס׳ טלפון אינו תקין"
});
extend("feeRegex", {
  ...regex,
  message: "הסכום אינו תקין"
});
extend("emailRegex", {
  ...regex,
  message: "כתובת הדוא״ל אינה תקינה"
});
// not required. Styles for built-in spinner
import "vue-promise-btn/dist/vue-promise-btn.css";
Vue.use(DatePicker);
Vue.use(VuePromiseBtn); // or with global options Vue.use(VuePromiseBtn, {})
Vue.component("svg-icon", SvgIcon);
/**
 * API component for HMC
 */
import API from "./api/api";
//import API from "./api/api-DEMO";
import GlobalFunction from "./mixins/mixins";
// import style
import "swiper/css/swiper.css";
import "vue-select/dist/vue-select.css";
import "vue-loaders/dist/vue-loaders.css";
Vue.use(VueLoaders);
Vue.use(VueAwesomeSwiper /* { default options with global component } */);
Vue.use(VModal, {
  dynamic: true,
  dynamicDefaults: {
    clickToClose: false,
    height: "auto",
    adaptive: true,
    styles: "background-color:initial;overflow:initial;box-shadow:initial;"
  }
});
import vSelect from "vue-select";
import select2 from "./components/Select2.vue";
import OtpInput from "@bachdgvn/vue-otp-input";

Vue.config.productionTip = false;
/*
const main_api = axios.create({
  baseUrl: "localhost/",
  headers: { "X-Requested-With": "XMLHttpRequest" }
});

//Vue.prototype.$ajax = main_api;
*/

require("moment/locale/he.js");

moment.locale("he");
Vue.prototype.$API = new API();
Vue.prototype.$moment = moment;
/* GLOBAL COMPOENTS */
Vue.component("v-select", vSelect);
Vue.component("select2", select2);
Vue.component("DatePick", DatePick, {
  nextMonthCaption: {
    type: String,
    default: ""
  },
  prevMonthCaption: {
    type: String,
    default: ""
  }
});
Vue.component("v-otp-input", OtpInput);
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("./firebase-messaging-sw.js")
//     .then(function(registration) {
//       console.log("Registration was successful: ", registration);
//     })
//     .catch(function(e) {
//       console.error("Registration has filed", e);
//     });
// }
Vue.mixin(mixins);
new Vue({
  router,
  store,
  mounted() {},
  render: h => h(App)
}).$mount("#app");
